<template>
  <div class="loader">
    <div class="lds-dual-ring"/>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>
